import PreviewContainer from '@bingads-webui-campaign-legacy/crud-ad/view/adsPreview/container';
import topTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/top.pug';
import sidebarTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/sidebar.pug';
import mobileTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/mobile.pug';
import nativeTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/native.pug';
import PreviewViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/textAd';
import MobileDecorator from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/mobileDecorator';
import LongAdTitleDecorator from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/longAdTitleDecorator';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default {
  buildPreview(viewModel) {
    return new PreviewContainer({
      contentClass: '.Text .preview-container',
      tabs: [{
        top: {
          template: topTemplate,
          viewModel: new LongAdTitleDecorator(new PreviewViewModel(viewModel)),
          title: i18n.get('Ad_TopView'),
        },
        sidebar: {
          template: sidebarTemplate,
          viewModel: new PreviewViewModel(viewModel),
          title: i18n.get('Ad_SideView'),
        },
        mobile: {
          template: mobileTemplate,
          viewModel: new MobileDecorator(new LongAdTitleDecorator(new PreviewViewModel(viewModel))),
          title: i18n.get('Ad_MobileView'),
        },
      }, {
        native: {
          template: nativeTemplate,
          viewModel: new PreviewViewModel(viewModel),
          title: i18n.get('Ad_NativeView'),
        },
      }],
    });
  },
};
